import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { clearCosting } from '@store/actions/CostingAction';
import {
	clearFilterResponse,
	clearGlobalFilter,
	removeItemFromGlobalFilter,
	storeItemInGlobalFilter
} from '@store/actions/FilterAction';
import { clearPhotography } from '@store/actions/PhotographyAction';
import { clearSampleRequest } from '@store/actions/SampleAction';
import { clearTeamFilter } from '@store/actions/TeamMemberAction';
import { setFilters } from '@store/common/action';
import { initialFilters } from '@store/common/reducer';

export const TopNavLink = ({ to, classes, title, onClick }) => {
	const dispatch = useDispatch();

	const handleTab = (status) => {
		let data = {};
		data = {
			key: status,
			name: 'status',
			value: status,
			subStatus: null,
			type: 'SELECT'
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const clearGlobalState = () => {
		if (to.startsWith('/orders/my-orders')) {
			dispatch(removeItemFromGlobalFilter({ name: 'filterCategory' }));
		} else {
			dispatch(clearGlobalFilter());
			if (to.startsWith('/sample/all')) {
				handleTab('PENDING');
			}
			// if (to.startsWith('/costing/initial')) {
			// 	handleTab(checkPrimaryUserType('FASHION_DESIGNER') ? 'REQUESTED' : 'PENDING,RUNNING');
			// }
		}

		dispatch(setFilters(initialFilters));
		dispatch(clearFilterResponse());
		dispatch(clearSampleRequest());
		dispatch(clearPhotography());
		dispatch(clearCosting());
		dispatch(clearTeamFilter());
		onClick(to);
	};

	return (
		<li className={classes}>
			<Link to={to} onClick={() => clearGlobalState()}>
				{title}
			</Link>
		</li>
	);
};
